import { matchPath, Navigate, useLocation } from 'react-router';

import { useAppSelector as useSelector } from 'dux/app/hooks';

import { productsCategories } from 'constants/products';

import LoadingScene from 'Scenes/LoadingScene';

import { forwardUTMIfNeeded, toRelativeURL } from 'utils/utm';

import {
  getFirstHaircareConsultationQuestionRoute,
  getFirstSkincareConsultationQuestionRoute,
} from 'dux/consultation/selectors';

const FirstQuestionLoading = () => {
  const { pathname } = useLocation();
  const { category } = matchPath('/consultation/:category/first-question', pathname)?.params || {};
  const firstHaircareQuestion = useSelector(getFirstHaircareConsultationQuestionRoute);
  const firstSkincareQuestion = useSelector(getFirstSkincareConsultationQuestionRoute);

  if (
    (category === productsCategories.HAIRCARE && !firstHaircareQuestion) ||
    (category === productsCategories.SKINCARE && !firstSkincareQuestion)
  ) {
    return <LoadingScene pastDelay />;
  }

  return (
    <Navigate
      to={toRelativeURL(
        forwardUTMIfNeeded(
          document.location,
          category === productsCategories.SKINCARE ? firstSkincareQuestion : firstHaircareQuestion
        )
      )}
    />
  );
};

export default FirstQuestionLoading;
